export default function Partners() {
  const partners = [
    {
      icon: 'ri-government-line',
      name: 'إمارة منطقة المدينة المنورة',
      type: 'راعي رسمي',
      description: 'الجهة الراعية الرسمية للملتقى',
      color: 'from-[#1B5E20] to-[#2E7D32]'
    },
    {
      icon: 'ri-building-4-line',
      name: 'مركز بحوث ودراسات المدينة',
      type: 'شريك معرفي',
      description: 'شريك في المحتوى العلمي والبحثي',
      color: 'from-[#D4AF37] to-[#B8941F]'
    },
    {
      icon: 'ri-smartphone-line',
      name: 'شركات الاتصالات',
      type: 'شريك تقني',
      description: 'دعم البنية التحتية التقنية',
      color: 'from-[#2E7D32] to-[#1B5E20]'
    },
    {
      icon: 'ri-bank-line',
      name: 'البنوك',
      type: 'شريك مالي',
      description: 'دعم المبادرات والبرامج الشبابية',
      color: 'from-[#1B5E20] to-[#0D3D10]'
    },
    {
      icon: 'ri-computer-line',
      name: 'شركات التقنية',
      type: 'شريك تقني',
      description: 'توفير الحلول التقنية والابتكارية',
      color: 'from-[#D4AF37] to-[#8B7520]'
    },
    {
      icon: 'ri-school-line',
      name: 'الجامعات',
      type: 'شريك أكاديمي',
      description: 'المساهمة في البحث العلمي والتطوير',
      color: 'from-[#2E7D32] to-[#1B5E20]'
    }
  ];

  return (
    <section id="partners" className="py-12 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#1B5E20] text-sm font-bold tracking-wider uppercase">الشركاء</span>
            <div className="h-1 w-16 bg-[#1B5E20] mt-2 mx-auto"></div>
          </div>
          <h2 className="text-5xl font-bold text-[#1B5E20] mb-6">الشركات والجهات المتوقعة للشراكة</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            شراكات استراتيجية مع جهات رائدة لدعم الملتقى وتحقيق أهدافه
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 overflow-hidden"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${partner.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
              <div className="relative z-10">
                <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${partner.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${partner.icon} text-4xl text-white`}></i>
                </div>
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 bg-[#F5F5DC] text-[#1B5E20] text-xs font-bold rounded-full">
                    {partner.type}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3 leading-tight">{partner.name}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{partner.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-[#1B5E20] to-[#0D3D10] rounded-3xl p-12 text-white">
            <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center mb-6">
              <i className="ri-trophy-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold mb-4">فرص الشراكة</h3>
            <p className="text-white/90 leading-relaxed mb-6">
              نرحب بالشراكات مع جميع الجهات الحكومية والخاصة وغير الربحية المهتمة بدعم الشباب والمساهمة في تحقيق أهداف الملتقى
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <i className="ri-check-line text-xl text-[#D4AF37]"></i>
                <span className="text-white/90 text-sm">رعاية رسمية للملتقى</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-check-line text-xl text-[#D4AF37]"></i>
                <span className="text-white/90 text-sm">المشاركة في المعرض المصاحب</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-check-line text-xl text-[#D4AF37]"></i>
                <span className="text-white/90 text-sm">دعم المبادرات الشبابية</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-check-line text-xl text-[#D4AF37]"></i>
                <span className="text-white/90 text-sm">شراكات استراتيجية طويلة الأمد</span>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#F5F5DC] to-[#FFF8DC] rounded-3xl p-12">
            <div className="w-16 h-16 rounded-2xl bg-[#1B5E20] flex items-center justify-center mb-6">
              <i className="ri-gift-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#1B5E20] mb-4">مميزات الشراكة</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              تحصل الجهات الشريكة على مجموعة من المميزات والفرص للتواصل مع الشباب والجمعيات
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <i className="ri-star-line text-xl text-[#D4AF37]"></i>
                <span className="text-gray-700 text-sm">ظهور العلامة التجارية في جميع المواد</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-star-line text-xl text-[#D4AF37]"></i>
                <span className="text-gray-700 text-sm">منصة عرض في المعرض المصاحب</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-star-line text-xl text-[#D4AF37]"></i>
                <span className="text-gray-700 text-sm">التواصل المباشر مع +200 مشارك</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-star-line text-xl text-[#D4AF37]"></i>
                <span className="text-gray-700 text-sm">تقارير وإحصائيات عن الملتقى</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <a
            href="#contact"
            className="inline-flex items-center gap-3 bg-[#1B5E20] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#2E7D32] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <span>للاستفسار عن فرص الشراكة</span>
            <i className="ri-arrow-left-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
